<template>
  <div class="activity-warp">
    <div class="activity-head">
      <img class="backicon" src="../../assets/imgs/close.png" @click="onBack">
      <div class="activity-title">网络切换</div>
    </div>
    <div style="margin: 10px">
      <div class="my-certity">
        <label>请选择网络</label>
      </div>
      <div>
        <van-radio-group v-model="swCard" checked-color="#1EBE86" @change="swCardClick">
          <div class="d-f" :class="swCard == 1?'b-b':'b-w'">
            <van-image :src="require('assets/imgs/mifi18.png')" width="40" height="40px"></van-image>
            <div class="d-t">
              <div class="d-1">智能优先网络</div>
              <div class="d-2">根据当地网络信号，智能分配最佳网络</div>
            </div>
            <div class="d-r">
              <van-radio name="1"></van-radio>
            </div>
          </div>
          <div class="d-f" :class="swCard == 2?'b-b':'b-w'">
            <van-image :src="require('assets/imgs/mifi17.png')" width="40" height="40px"></van-image>
            <div class="d-t">
              <div class="d-1 mg20">中国电信</div>
            </div>
            <div class="d-r">
              <van-radio name="46003"></van-radio>
            </div>
          </div>
          <div class="d-f" :class="swCard == 3?'b-b':'b-w'">
            <van-image :src="require('assets/imgs/mifi19.png')" width="40" height="40px"></van-image>
            <div class="d-t">
              <div class="d-1 mg20">中国移动</div>
            </div>
            <div class="d-r">
              <van-radio name="46000"></van-radio>
            </div>
          </div>
          <div class="d-f" :class="swCard == 4?'b-b':'b-w'">
            <van-image :src="require('assets/imgs/mifi20.png')" width="40" height="40px"></van-image>
            <div class="d-t">
              <div class="d-1 mg20">中国联通</div>
            </div>
            <div class="d-r">
              <van-radio name="46001"></van-radio>
            </div>
          </div>
        </van-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
import { ORDER_LIST } from '../../apis/user'
import { mapState } from "vuex";
import { MIFI_DEVICE_OPERATION_CMD, MIFI_PRODUCT_RCHARGE } from "@/apis/cabinet";
export default {
  components: {
  },
  computed: {
    ...mapState(['mifisn'])
  },
  data () {
    return {
      swCard: ''
    }
  },
  methods: {
    swCardClick () {
      this.$loading(true)
      this.$post(
        MIFI_DEVICE_OPERATION_CMD, {
          devId: this.mifisn,
          ispname: this.swCard
        }, (resp) => {
          this.$loading(false)
          this.$toast("切换成功")
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    onBack () {
      this.$router.go(-1)
    },
    backHome() {
      this.$router.push('/')
    }
  },
  created () {
  }
}
</script>

<style lang="less">
.activity-warp {
  height: 100vh;
  // background: linear-gradient(#00AB46, #1A2229);
  background: #F4F4F4;
  .activity-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;

    .backicon {
      width: 50px;
    }
    .activity-title {
      text-align: center;
      width: 100%;
      font-family: Montserrat, Montserrat;
      font-weight: bold;
      font-size: 36px;
      color: #1A2229;
    }
  }
}
.d-t{
  padding: 0 0 0 15px;
}
.d-f{
  display: flex;
  background: white;
  padding: 20px 0 20px 10px;
  border-radius: 15px;
  margin: 20px 0;
}
.b-b{
  border: 1px solid #1EBE86;
}
.b-w{
  border: 1px solid #ffffff;
}
.d-r{
  position: absolute;
  right: 35px;
  margin-top: 20px;
}
.d-1{
  color: #333333;
  font-family: MyFont8;
  font-size: 10pt;
}
.d-2{
  color: #999999;
  font-family: MyFont8;
  font-size: 10pt;
}
.mg20{
  margin: 20px 0;
}
</style>
